import Icon from '../components/Icon.vue'

Icon.register({
  'hockey-puck': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M0 160c0-53 114.6-96 256-96s256 43 256 96-114.6 96-256 96-256-43-256-96zM0 242.2c113.5 82.4 398.6 82.3 512 0v109.8c0 53-114.6 96-256 96s-256-43-256-96v-109.8z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/hockey-puck.js
// module id = 1457
// module chunks = 0